/**
 * List Schema of RastreamentoHistorico
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {RastreamentoHistorico} from '@/model/resource/RastreamentoHistorico'

/* TODO: review generated schema */
export class ListRastreamentoHistoricoSchema extends Schema {
  readonly name = 'ListRastreamentoHistorico'

  readonly fieldSet: FieldSet<RastreamentoHistorico> = {
    idRastreamentoHistoricoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    rastreamento: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.rastreamento?.$id,
      },
    }),
    latitude: (): FieldComponent => ({
      is: Component.Render,
    }),
    longitude: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataPosicao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataPosicao),
      },
    }),
    statusCarga: (): FieldComponent => ({
      is: Component.Render,
    }),
    idExterno: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
